<div class="page-body"> 
  <div class="row">
    <div class="col-sm-12">
      <app-card [cardOptionBtnValue]="'global.add_btn_text'|translate " [cardOptionBtnIcon]="'feather icon-plus'" [cardOptionBtn]="true" [cardRouterLink]="'/back-office/system-user/add'" [title]="'global.overview'|translate">
        <app-grid [grid]="grid" ></app-grid>
      </app-card>
    </div>
  </div>
</div>
<app-modal-basic #deactive2FAModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'auth.2fa.deactivate' | translate}}:</h4>
    <button type="button" class="close basic-close" (click)="deactive2FAModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'auth.2fa.deactivate.sure' | translate}}: <span [innerHTML]="collectionName"></span></p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="deactive2FAModal.hide()">{{'global.cancel'|translate}}</button>
    <button [disabled]="disableDeactive2FAButton" type="button" class="btn btn-primary ripple light" (click)="deactive2FA()">{{'global.deactivate'|translate}}</button>
  </div>
</app-modal-basic>
<app-modal-basic #deleteModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'menu.system-users.delete.title' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <span [innerHTML]="collectionName"></span></p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
    <button [disabled]="disableDeleteButton" type="button" class="btn btn-primary ripple light" (click)="softDelete()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>